// Time-of-day adaptive hero: picks 1 of 5 dayparts from local hour.
import { HERO_BLUR } from "./heroBlur";

const G = {
  morning: {
    key: "morning", img: "/hero/morning.webp", blur: HERO_BLUR.morning,
    greet: { हिंदी: "सुप्रभात", English: "Good morning", Hinglish: "Suprabhaat" }, emoji: "🌅",
    scrim: "linear-gradient(180deg, rgba(60,30,0,.28) 0%, rgba(0,0,0,.05) 45%, rgba(0,0,0,0) 100%)",
  },
  afternoon: {
    key: "afternoon", img: "/hero/afternoon.webp", blur: HERO_BLUR.afternoon,
    greet: { हिंदी: "नमस्ते", English: "Namaste", Hinglish: "Namaste" }, emoji: "☀️",
    scrim: "linear-gradient(180deg, rgba(0,20,40,.30) 0%, rgba(0,0,0,.04) 50%, rgba(0,0,0,0) 100%)",
  },
  evening: {
    key: "evening", img: "/hero/evening.webp", blur: HERO_BLUR.evening,
    greet: { हिंदी: "शुभ संध्या", English: "Good evening", Hinglish: "Shubh sandhya" }, emoji: "🌇",
    scrim: "linear-gradient(180deg, rgba(50,20,0,.34) 0%, rgba(0,0,0,.06) 50%, rgba(0,0,0,0) 100%)",
  },
  night: {
    key: "night", img: "/hero/night.webp", blur: HERO_BLUR.night,
    greet: { हिंदी: "शुभ रात्रि", English: "Good night", Hinglish: "Shubh raatri" }, emoji: "🌙",
    scrim: "linear-gradient(180deg, rgba(0,0,20,.55) 0%, rgba(0,0,0,.25) 50%, rgba(0,0,0,.1) 100%)",
  },
  latenight: {
    key: "latenight", img: "/hero/latenight.webp", blur: HERO_BLUR.latenight,
    greet: { हिंदी: "अभी भी जाग रहे हैं", English: "Still awake", Hinglish: "Abhi bhi jaag rahe hain" }, emoji: "🌙",
    tail: { हिंदी: "आराम भी ज़रूरी है", English: "rest is important too", Hinglish: "aaram bhi zaroori hai" },
    scrim: "linear-gradient(180deg, rgba(0,0,15,.62) 0%, rgba(0,0,0,.32) 50%, rgba(0,0,0,.12) 100%)",
  },
};

export function getDaypart(d = new Date()) {
  const h = d.getHours() + d.getMinutes() / 60;
  if (h >= 5 && h < 11) return G.morning;
  if (h >= 11 && h < 16) return G.afternoon;
  if (h >= 16 && h < 18.5) return G.evening;
  if (h >= 18.5 && h < 23) return G.night;
  return G.latenight;
}

// "सुप्रभात, राजेश जी! 🌅"
export function greeting(dp, name, language) {
  const g = dp.greet[language] || dp.greet["हिंदी"];
  const nm = (name || "").trim().split(/\s+/)[0];
  const ji = language === "English" ? "" : " जी";
  let base = `${g}, ${nm}${ji}! ${dp.emoji}`;
  if (dp.tail) base += ` — ${dp.tail[language] || dp.tail["हिंदी"]}`;
  return base;
}
